import { render, staticRenderFns } from "./KusDocumentPreview.vue?vue&type=template&id=005b8c1e"
import script from "./KusDocumentPreview.vue?vue&type=script&lang=js"
export * from "./KusDocumentPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports